// extracted by mini-css-extract-plugin
export default {"wrapper":"Anywhere-module__wrapper___vr43D","selection":"Anywhere-module__selection___HrBFV"};